/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type RecommendationsQueryVariables = Types.Exact<{
    placement: Types.Scalars['String'];
}>;

export type RecommendationsQuery = {
    __typename: 'Query';
    recommendations: Types.Maybe<
        Array<{
            __typename: 'Recommendation';
            mpvID: string;
            name: string;
            fallbackImageURL: Types.Maybe<string>;
            source: Types.RecommendationSource;
            price: Types.Maybe<{
                __typename: 'ExpertServicePrice';
                currency: string;
                listPrice: { __typename: 'PriceDetailLegacy'; taxed: number; untaxed: number };
                listPriceCents: { __typename: 'PriceDetail'; taxed: number; untaxed: number };
            }>;
        }>
    >;
};

export const RecommendationsDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'Recommendations' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'placement' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recommendations' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'placement' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'placement' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'mpvID' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'price' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'listPrice' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'taxed' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'untaxed',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'listPriceCents' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'taxed' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'untaxed',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'currency' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'fallbackImageURL' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};

/**
 * __useRecommendationsQuery__
 *
 * To run a query within a React component, call `useRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendationsQuery({
 *   variables: {
 *      placement: // value for 'placement'
 *   },
 * });
 */
export function useRecommendationsQuery(
    baseOptions: Apollo.QueryHookOptions<RecommendationsQuery, RecommendationsQueryVariables>
) {
    return Apollo.useQuery<RecommendationsQuery, RecommendationsQueryVariables>(
        RecommendationsDocument,
        baseOptions
    );
}
export function useRecommendationsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<RecommendationsQuery, RecommendationsQueryVariables>
) {
    return Apollo.useLazyQuery<RecommendationsQuery, RecommendationsQueryVariables>(
        RecommendationsDocument,
        baseOptions
    );
}
export type RecommendationsQueryHookResult = ReturnType<typeof useRecommendationsQuery>;
export type RecommendationsLazyQueryHookResult = ReturnType<typeof useRecommendationsLazyQuery>;
export type RecommendationsQueryResult = Apollo.QueryResult<
    RecommendationsQuery,
    RecommendationsQueryVariables
>;
